import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["onChange"],
      _excluded2 = ["onChange"],
      _excluded3 = ["onChange"];
import React from 'react';
import DatePicker from 'react-datepicker';
import { ReactDatePickerStyles } from '../style';

require('react-datepicker/dist/react-datepicker.css');

export const ReactDateTimePicker = _ref => {
  let {
    onChange
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  let {
    selectedDate
  } = props;
  const backgroundColor = props.disabled ? 'gray' : props.backgroundColor;

  if (typeof selectedDate === 'number') {
    selectedDate = new Date(selectedDate);
  }

  let {
    minimumDate
  } = props;

  if (typeof minimumDate === 'number') {
    minimumDate = new Date(minimumDate);
  }

  let {
    maximumDate
  } = props;

  if (typeof maximumDate === 'number') {
    maximumDate = new Date(maximumDate);
  }

  return /*#__PURE__*/React.createElement(ReactDatePickerStyles, {
    position: props.position,
    zIndex: props.zIndex,
    inputWidth: props.inputWidth || '14rem',
    inputTextAlign: props.inputTextAlign || 'center',
    inputMargin: props.inputMargin,
    popperPosition: props.popperPosition,
    popperInset: props.popperInset,
    popperTransform: props.popperTransform,
    backgroundColor: backgroundColor || 'transparent'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DatePicker, _extends({
    autoComplete: "off",
    showTimeSelect: true,
    dateFormat: "MM-dd-yy h:mm a",
    onChange: onChange,
    selected: selectedDate,
    minDate: minimumDate,
    maxDate: maximumDate,
    strictParsing: true,
    fixedHeight: true
  }, props))));
};
export const ReactDatePicker = _ref2 => {
  let {
    onChange
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  let {
    selectedDate
  } = props;
  const backgroundColor = props.disabled ? 'gray' : props.backgroundColor;

  if (typeof selectedDate === 'number') {
    selectedDate = new Date(selectedDate);
  }

  let {
    minimumDate
  } = props;

  if (typeof minimumDate === 'number') {
    minimumDate = new Date(minimumDate);
  }

  let {
    maximumDate
  } = props;

  if (typeof maximumDate === 'number') {
    maximumDate = new Date(maximumDate);
  }

  return /*#__PURE__*/React.createElement(ReactDatePickerStyles, {
    position: props.position,
    zIndex: props.zIndex,
    inputWidth: props.inputWidth || '6.75rem',
    inputTextAlign: props.inputTextAlign || 'center',
    inputMargin: props.inputMargin,
    popperPosition: props.popperPosition,
    popperInset: props.popperInset,
    popperTransform: props.popperTransform,
    backgroundColor: backgroundColor,
    color: props.color || 'inherit'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DatePicker, _extends({
    autoComplete: "off",
    dateFormat: "MM-dd-yy",
    onChange: onChange,
    strictParsing: true,
    selected: selectedDate,
    minDate: minimumDate,
    maxDate: maximumDate,
    fixedHeight: true
  }, props))));
};
export const ReactTimePicker = _ref3 => {
  let {
    onChange
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  let {
    selectedDate
  } = props;
  const backgroundColor = props.disabled ? 'gray' : props.backgroundColor;

  if (typeof selectedDate === 'number') {
    selectedDate = new Date(selectedDate);
  }

  let {
    minimumDate
  } = props;

  if (typeof minimumDate === 'number') {
    minimumDate = new Date(minimumDate);
  }

  let {
    maximumDate
  } = props;

  if (typeof maximumDate === 'number') {
    maximumDate = new Date(maximumDate);
  }

  return /*#__PURE__*/React.createElement(ReactDatePickerStyles, {
    position: props.position,
    zIndex: props.zIndex,
    inputWidth: props.inputWidth || '5.5rem',
    inputTextAlign: props.inputTextAlign || 'center',
    inputMargin: props.inputMargin,
    popperPosition: props.popperPosition,
    popperInset: props.popperInset,
    popperTransform: props.popperTransform,
    backgroundColor: backgroundColor || 'transparent'
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DatePicker, _extends({
    autoComplete: "off",
    dateFormat: "h:mm a",
    showTimeSelectOnly: true,
    onChange: onChange,
    strictParsing: true,
    selected: selectedDate,
    minDate: minimumDate,
    maxDate: maximumDate,
    fixedHeight: true
  }, props))));
};